import React, { MouseEventHandler } from "react";

import {
  typographyBodyLineHeightMap,
  typographyBodySizeMap
} from "../../../styles/typography/typography";
import { styledWithConfig } from "../../layout";
import ButtonLoadingStateProvider from "./components/ButtonLoadingStateProvider";
import { SharedButtonProps } from "./types";
import getBorderStyleProps from "./utils/getBorderStyleProps";
import getMiscStyleProps from "./utils/getMiscStyleProps";
import getPaddingStyleProps from "./utils/getPaddingStyleProps";
import { sizeToTypographyBodySizeMap } from "./utils/sizeToTypographyBodySizeMap";
import useButtonColorStyleProps from "./utils/useButtonColorStyleProps";

const ButtonComponent = styledWithConfig("button");

export type Props = {
  onClick: MouseEventHandler;
} & SharedButtonProps;

export default function Button({
  onClick,
  children,
  tone = "primary",
  fill = "filled",
  size = "standard",
  disabled = false,
  loading = false,
  width = ["100%", undefined],
  fillHeight = false,
  accessibilityLabel
}: Props) {
  const miscStyleProps = getMiscStyleProps({
    width,
    fillHeight,
    accessibilityLabel,
    disabled,
    loading
  });

  const colorStyleProps = useButtonColorStyleProps({
    fill,
    tone,
    disabled
  });

  const borderStyleProps = getBorderStyleProps(fill);

  const paddingStyleProps = getPaddingStyleProps(size);

  const typographyBodySize = sizeToTypographyBodySizeMap[size];

  return (
    <ButtonComponent
      onClick={onClick}
      disabled={disabled || loading}
      {...miscStyleProps}
      {...colorStyleProps}
      {...borderStyleProps}
      {...paddingStyleProps}
      {...typographyBodySizeMap[typographyBodySize]}
      {...typographyBodyLineHeightMap.large}
    >
      <ButtonLoadingStateProvider loading={loading} size={size}>
        {children}
      </ButtonLoadingStateProvider>
    </ButtonComponent>
  );
}
